import Icon from '@material-ui/icons/Movie';

import List from './List';

export default {
  name: 'reports/movie',
  icon: Icon,
  list: List,
};
